module.exports = __webpack_public_path__ + "static/media/flag-de.3561223b.svg";